<template>
  <div class="size1 bg0 where1-parent">
    <div
      class="size3 flex-col-sb flex-w p-l-50 p-t-25 p-b-45 respon1 reponsive-celular"
    >
      <center class="center-header-login">
        <img
          src="@/assets/LOGO SEPLAG - AZUL (T) VAZADO.svg"
          class="icon-login"
        />
        <p class="texto-sistema">Portal do Servidor</p>
      </center>
      <div class="p-b-10 p-t-50">
        <p class="m1-txt1 p-b-36" style="text-align: center">
          Informe o usuário e a senha de acesso
        </p>
        <form ref="formRef" class="p-grid p-fluid">
          <div
            class="wrap-input100 m-b-10 validate-input"
            data-validate="Nome requerido"
          >
            <input
              class="s2-txt1 placeholder0 input100"
              type="text"
              id="login"
              name="email"
              placeholder="Matrícula ou Login"
              v-model="user.login"
            />
            <span class="focus-input100"></span>
          </div>
          <div
            class="wrap-input100 m-b-20 validate-input"
            data-validate="Senha requerido"
          >
            <input
              class="s2-txt1 placeholder0 input100"
              type="password"
              id="senha"
              name="password"
              v-model="user.senha"
              placeholder="Senha"
              v-on:keyup.enter="logar(user)"
            />
            <span class="focus-input100"></span>
          </div>
          <div class="w-full-sm p-col-6">
            <button
              class="s2-txt2 size4 bg1 bor1 hov1 trans-04"
              type="button"
              @click="logar()"
            >
              Entrar no sistema
            </button>
          </div>
          <div class="w-full-sm p-col-6">
            <button
              class="s2-txt2 size4 bg2 bor1 hov1 trans-04"
              type="button"
              @click="portalPensionista()"
            >
              Entrar como Pensionista
            </button>
          </div>
        </form>
        <div class="p-grid p-fluid">
          <p
            class="p-col-6 s2-txt3 p-t-18"
            style="cursor: pointer"
            @click="resetarSenha()"
          >
            Esqueci a minha senha
          </p>
          <p
            class="p-col-6 p-md-4 p-md-offset-2 s2-txt3 p-t-18"
            style="cursor: pointer; text-align: right"
            @click="obterInfAcesso()"
          >
            Informações de acesso
          </p>
        </div>
      </div>
      <div class="p-col-12">
        <img src="@/assets/produto-STI.png" class="img-footer-phone" />
      </div>
    </div>

    <div
      class="flex-c-m bg-img1 size2 where1 overlay1 where2 respon2 display"
      style=""
    >
      <!-- <div class="wsize2 flex-w flex-c-m cd100 js-tilt" style="will-change: transform; transform: perspective(300px) rotateX(0deg) rotateY(0deg);">
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('decreto')">
                    <span class="l2-txt1 p-b-9 days"><i class="pi pi-file-o"></i></span>
                    <span class="s2-txt4">Decreto de<br>Monitoramento</span>
                </div>
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('manuais')">
                    <span class="l2-txt1 p-b-9 hours"><i class="pi pi-copy"></i></span>
                    <span class="s2-txt4">Manuais e<br>Autocapacitação</span>
                </div>
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('perguntas')">
                    <span class="l2-txt1 p-b-9 minutes"><i class="pi pi-question"></i></span>
                    <span class="s2-txt4">Perguntas<br>Frequentes</span>
                </div>
                <div class="flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15" @click="listarDocumentos('treinamento')">
                    <span class="l2-txt1 p-b-9 seconds"><i class="pi pi-align-center"></i></span>
                    <span class="s2-txt4">Lista de<br>Treinamento</span>
                </div>
            </div> -->
    </div>

    <cadastro-rapido
      tituloTela="Informações de Acesso"
      v-model="exibirTelaInfo"
      tamanhoTela="800"
      :confirmarSimples="true"
      :visivelFechar="false"
      :onConfirmarSimples="() => (exibirTelaInfo = !exibirTelaInfo)"
    >
      <p style="font-size: 14px">
        Para acessar o Portal do Servidor, tenha em mãos seus dados de
        matrícula, CPF, Data de Nascimento e E-mail.
      </p>

      <p style="font-size: 14px">
        Sendo seu 1º acesso, será necessário realizar a ativação do cadastro.
        Para isso, clique no no link "Ativação/Esqueci a minha senha". Você
        receberá um link para ativação no e-mail cadastrado no Sistema Estadual
        de Administração de Pessoas - SEAP
      </p>

      <p style="font-size: 14px">
        Após a ativação, você receberá um segundo e-mail com a uma senha
        provisória. Logo em seguida, será solicitado a inclusão da senha atual
        (provisória) e o cadastro de uma nova senha.
      </p>

      <p style="font-size: 14px">
        Caso precise cadastrar ou atualizar seu e-mail, procure o RH do seu
        Órgão para atualização da informação.
      </p>

      <p style="font-size: 14px">
        PENSIONISTA, você beneficiário de pensão deve acessar através do Portal
        antigo, acessível através do botão "Entrar como Pensionista" na tela
        principal.
      </p>

      <p style="font-size: 14px">
        Em caso de suporte, envie um e-mail para portalservidor@seplag.mt.gov.br
      </p>
    </cadastro-rapido>

    <cadastro-rapido
      tituloTela="ATENÇÃO!!"
      v-model="exibirTelaInstrucao"
      tamanhoTela="732"
      :confirmarSimples="true"
      :visivelFechar="false"
      :onConfirmarSimples="() => (exibirTelaInstrucao = !exibirTelaInstrucao)"
    >
      <div class="p-col-12">
        <p style="font-size: 14px; text-align: justify">
          Bem vindo ao novo Portal do Servidor! Instruções de Acesso
        </p>

        <p style="font-size: 14px; text-align: justify">
          <i class="pi pi-check"></i> Para seu primeiro acesso ao portal utilize
          o recurso "Esqueci minha senha". O sistema enviará um e-mail com
          instruções para resetar a senha.
        </p>

        <p style="font-size: 14px; text-align: justify">
          <i class="pi pi-check"></i> Caso você não receba o e-mail verifique se
          não foi para a caixa de SPAM e/ou LIXEIRA. Após verificação, caso não
          tenha recebido, entre em contato com o RH do seu órgão para a correção
          do e-mail no SEAP. A alteração leva 24 horas para ser reconhecida no
          Portal do Servidor.
        </p>

        <p style="font-size: 14px; text-align: justify">
          <i class="pi pi-check"></i> Aposentados e pensionistas por morte que
          ainda não possuem e-mail válido cadastrado deverão encaminhar um
          e-mail para <strong>cadastro@mtprev.mt.gov.br</strong>, com CPF, RG,
          comprovante de residência, telefone celular e e-mail a ser cadastrado.
        </p>

        <p style="font-size: 14px; text-align: justify">
          <i class="pi pi-check"></i> Pensionistas poderão continuar acessando o
          portal do servidor antigo com a senha que já possuem:
        </p>

        <p style="text-align: center">
          <a
            href="https://portaldoservidor.seplag.mt.gov.br/portalservidor/login.xhtml"
            style="font-size: 14px"
            target="_blank"
            >https://portaldoservidor.seplag.mt.gov.br/portalservidor/login.xhtml</a
          >
        </p>

        <br />

        <small style="font-size: 12px; text-align: left; font-weight: bold">
          Obs: Se persistirem dúvidas, enviar e-mail para o suporte do Portal do
          Servidor: portalservidor@seplag.mt.gov.br
        </small>
      </div>
    </cadastro-rapido>

    <cadastro-rapido
      tituloTela="Esqueci a minha senha"
      tamanhoTela="800"
      v-model="exibirTelaSenha"
      :modoEdicao="modoEdicao"
      :onEnviarLinkAtivacao="alterarRegistro"
    >
      <div class="p-grid">
        <div
          role="alert"
          class="p-messages p-component p-messages-warn p-col-6"
        >
          <div
            style="text-align: center; font-size: 12px"
            class="p-messages-wrapper"
          >
            <p>
              (1) A sua senha inicial será encaminhada por e-mail após clicar na
              opção "Enviar link de ativação". Após o acesso ao portal com a
              senha provisória, será solicitada a alteração de senha.
            </p>
            <p>
              (2) Caso não consiga acessar o Portal, tente redefinir sua senha
              clicando no "Enviar link de ativação".
            </p>
            <p>
              (3) Caso seja verificado que o e-mail exibido não lhe está mais
              acessível, entre em contato com seu Órgão para atualização do
              e-mail no SEAP.
            </p>
          </div>
        </div>
        <div class="p-col-6">
          <!--<Rotulo nome="Tipo de Usuário" cols="12" >
                        <Dropdown v-model="registro.tipoUsuario" :options="tiposUsuario" optionLabel="descTipo" placeholder="Selecione um tipo" />
                    </Rotulo>-->
          <Rotulo nome="Matrícula ou Login" cols="12">
            <InputText type="text" v-model="registro.matricula" v-required />
          </Rotulo>
          <Rotulo nome="CPF" cols="12">
            <InputMask
              mask="999.999.999-99"
              placeholder="999.999.999-99"
              v-model="registro.cpf"
              v-required
            />
          </Rotulo>
          <Rotulo nome="Data Nascimento" cols="12">
            <InputMask
              mask="99/99/9999"
              placeholder="dd/mm/aaaa"
              v-model="registro.dataNascimento"
              v-required
            />
          </Rotulo>
        </div>
      </div>
    </cadastro-rapido>

    <!-- MODAL ALTERAR SENHA -->
    <Dialog
      header="Alterar Senha"
      :visible.sync="exibirTelaNovaSenha"
      :style="{ width: '24em' }"
      :modal="true"
      :closeOnEscape="false"
      :closable="false"
    >
      <div class="p-grid">
        <Rotulo nome="Nova Senha" cols="12">
          <Password
            v-model="senhaNova"
            weakLabel="FÁCIL"
            mediumLabel="MÉDIO"
            strongLabel="DIFÍCIL"
            :toggleMask="true"
            :inputStyle="{ width: '100%' }"
            :style="{ width: '100%' }"
          />
        </Rotulo>
        <Rotulo nome="Confirma Nova Senha" cols="12">
          <Password
            v-model="confirmaSenhaNova"
            :feedback="false"
            :toggleMask="true"
            :inputStyle="{ width: '100%' }"
            :style="{ width: '100%' }"
          />
        </Rotulo>
        <div class="p-col-12" style="display: flex; justify-content: center">
          <Button
            label="Salvar"
            icon="pi pi-check"
            @click="alterarSenhaNova"
            class="p-button-outlined"
          />
          <Button
            label="Cancelar"
            icon="pi pi-times"
            @click="fecharConfirmacao"
            class="p-button-outlined p-button-danger"
            style="margin-left: 5px"
          />
        </div>
      </div>
    </Dialog>

    <!-- MODAL CONFIRMA ALTERAR SENHA -->
    <!-- <Dialog
      header="Confirmação"
      :visible.sync="exibirModalConfirmacaoSenha"
      :style="{ width: '24em' }"
      :modal="true"
    >
      <div
        class="confirmation-content"
        :style="{ color: colorMenssagemConfirmacao }"
      >
        <i
          class="pi pi-exclamation-triangle p-mr-3"
          style="font-size: 2em"
          v-if="colorMenssagemConfirmacao != '#07631e'"
        />
        <span style="text-align: justify">{{ mensagemConfirmacao }}</span>
      </div>
      <template #footer>
        <Button
          label="Fechar"
          icon="pi pi-times"
          @click="fecharConfirmacao"
          class="p-button-text"
        />
      </template>
    </Dialog> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Rotulo from "@/template/RotuloSeplag.vue";
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import { baseApiUrl } from "@/config/global";
//import moment from 'moment'

const getDefaultState = () => {
  return {
    matricula: "",
    email: "",
  };
};

export default {
  name: "Login",
  computed: mapGetters(["isUserLogado"]),
  components: { Rotulo, CadastroRapido },
  modoEdicao: "logar",

  mounted() {
    this.urlLogin = window.location.origin + "/portalservidor";
    var count = Object.keys(this.$route.query).length;
    if (count > 0) {
      this.codigoUrl = this.$route.query.codigo;
      if (this.codigoUrl) {
        this.validarNovaSenha();
      } else {
        this.$toast.add({
          severity: "success",
          summary: "Senha Alterada com SUCESSO!",
          life: 9000,
        });
      }
    } else {
      this.exibirTelaInstrucao = true;
    }
  },
  data: function () {
    return {
      user: {
        login: "",
        senha: "",
        identificacao: "",
        vue: this,
      },
      registro: getDefaultState(),
      codigoUrl: null,
      exibirTelaInfo: false,
      modoEdicao: "alterar",
      urlLogin: null,
      tiposUsuario: [
        { flgTipo: "S", descTipo: "Servidor" },
        { flgTipo: "A", descTipo: "Aposentado" },
        { flgTipo: "P", descTipo: "Pensionista" },
      ],
      tiposLogin: [
        { flgTipo: "S", descTipo: "Servidor ou Aposentado" },
        { flgTipo: "P", descTipo: "Pensionista" },
      ],
      selectedTipoLogin: { flgTipo: "S", descTipo: "Servidor ou Aposentado" },
      exibirTelaSenha: false,
      exibirModalConfirmacaoSenha: false,
      mensagemConfirmacao: null,
      colorMenssagemConfirmacao: "#07631e",
      apiUrlRecursoBuscarServidor: "publicos/iniciaregistroservidor",
      apiUrlRecursoBuscarEmpregador: "publicos/iniciaregistroempregado",
      exibirTelaInstrucao: false,
      exibirTelaNovaSenha: false,
      senhaNova: "",
      confirmaSenhaNova: "",
    };
  },
  methods: {
    ...mapActions(["logarUsuario"]),
    obterInfAcesso() {
      (this.exibirTelaSenha = false), (this.exibirTelaInfo = true);
    },
    resetarSenha() {
      (this.exibirTelaSenha = true), (this.exibirTelaInfo = false);
      this.modoEdicao = "enviaremailativacao";
    },
    portalPensionista() {
      window.location.href =
        "https://portaldoservidor.seplag.mt.gov.br/portalservidor/login.xhtml";
    },
    async logar() {
      if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
        this.$store.commit("setLoader", true);
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha("login");
        if (token) {
          this.$store.commit("setTokenrecaptcha", token);
          let res = await this.logarUsuario(this.user);
          if (res) {
            this.$store.commit("setUserLogado", true);
          }
        } else {
          this.$store.commit("setLoader", false);
          this.$toast.add({
            severity: "error",
            summary:
              "Erro ao Validar o Recaptcha, PorFavor recarregue a pagina e tente novamente",
            life: 15000,
          });
        }
      } else {
        let res = await this.logarUsuario(this.user);
        if (res) {
          this.$store.commit("setUserLogado", true);
        }
      }
    },
    fecharConfirmacao() {
      this.exibirModalConfirmacaoSenha = false;
      this.exibirTelaNovaSenha = false;
    },

    validarNovaSenha() {
      this.$http
        .get(
          `${baseApiUrl}/publicos/esquecisenha/validaHash?hash=${this.codigoUrl}`
        )
        .then(() => {
          this.exibirTelaNovaSenha = true;
        });

      // var objValida = {
      //   codigoValidacao: this.codigoUrl,
      //   pathAplicacao: this.urlLogin,
      //   nomeSistema: process.env.VUE_APP_TITLE,
      //   assinaturaEmail: 'COORDENADORIA DE MONITORAMENTO DE PESSOAL',
      // };
      // if (this.exibirTelaInstrucao) {
      //   this.exibirTelaInstrucao = false;
      // }
      // this.$http
      //   .post(
      //     `${baseApiUrl}/publicos/esquecisenha/novasenha`,
      //     JSON.stringify(objValida)
      //   )
      //   .then((res) => {
      //     this.mensagemConfirmacao = res.data.mensagem;
      //     this.colorMenssagemConfirmacao = '#07631e';
      //     this.exibirModalConfirmacaoSenha = true;
      //   });
      // .catch(error => {
      //     this.mensagemConfirmacao = error.response.data[0].msgUsuario
      //     this.colorMenssagemConfirmacao = "#bf1b1b"
      //     this.exibirModalConfirmacaoSenha = true
      // })
    },
    alterarSenhaNova() {
      if (this.senhaNova == this.confirmaSenhaNova) {
        let requestBody = {
          hash: this.codigoUrl,
          senhaNova: this.senhaNova,
        };
        this.$http
          .post(
            `${baseApiUrl}/publicos/esquecisenha/alterarsenha`,
            JSON.stringify(requestBody)
          )
          .then(() => {
            this.exibirModalConfirmacaoSenha = false;
            this.exibirTelaNovaSenha = false;
            window.location.href = this.urlLogin + "?msg=ok";
          });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Confirmação de Senha Invalida",
          life: 15000,
        });
      }
    },
    alterarRegistro() {
      var dadosForm = {
        login: this.registro.matricula,
        cpf: this.registro.cpf,
        dataNascimento: this.registro.dataNascimento,
        pathAplicacao: this.urlLogin,
        nomeSistema: process.env.VUE_APP_TITLE,
        assinaturaEmail: "COORDENADORIA DE MONITORAMENTO DE PESSOAL",
      };
      this.$http
        .post(`${baseApiUrl}/publicos/esquecisenha`, JSON.stringify(dadosForm))
        .then((res) => {
          (this.exibirTelaSenha = false),
            this.$toast.add({
              severity: "success",
              summary: res.data.mensagem,
              life: 9000,
            });
        })
        .catch(() => {
          this.exibirTelaSenha = false;
        });
    },
  },
  created() {},
};
</script>

<style scoped>
.messages-error {
  background: #ffcdd2;
  border: solid #f44336;
  border-width: 0 0 0 6px;
  color: #b71c1c;
  padding: 1rem 1.5rem;
}

.messages-info {
  background: #b3e5fc;
  border: solid #03a9f4;
  border-width: 0 0 0 6px;
  color: #01579b;
  padding: 1rem 1.5rem;
}

.imagem-fundo {
  background: url("../../assets/img-direito.png");
  background-position: 0% 45%;
  background-repeat: round;
  background-size: auto;
  height: 100.8vh;
  flex-grow: 1;
}

.img-sti {
  margin-bottom: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  width: 8%;
}

.texto-sistema {
  font-size: 20px;
  color: #005494;
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.logingridcontrol1 {
  background-color: #005494;
  background: url("../../assets/layout/img-login-pessoas.jpg");
  background-size: 105%;
  height: 75%;
  min-height: 75%;
}
.logingridcontrol2 {
  min-height: 75%;
  height: 75%;
  background-color: #fff;
}

.logingridcontrol2 .border {
  border: 1px dashed #005494;
  margin-top: 2px;
  border-left: 0;
  height: 100%;
}
.p-grid {
  margin-right: 0;
  margin-left: 0;
}

.loginformgvesqueci a {
  color: white;
}
.bg1 {
  background-color: #007ad9;
}
.bg2 {
  background-color: green;
}

.wrap-pic1 {
  width: 70%;
}
.bg-img1 {
  background-image: url("../../assets/teste2-mg.jpg");
}
.texto-sistema {
  font-size: 40px;
  color: #005494;
  font-weight: bold;
  padding: 0;
  margin: 0;
}
.icon-login {
  width: 60%;
  margin-top: 3vw;
  margin-bottom: 2vw;
  margin-left: -3.2vw;
}
.img-top-phone {
  width: 90%;
  margin-top: 12vw;
  margin-left: -6vw;
}
.img-footer-phone {
  width: 12vw;
  margin-left: 8vw;
  margin-top: 4vw;
}
.m1-txt1 {
  font-size: 15px;
}
.s2-txt4 {
  text-transform: none;
  font-family: "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 15px;
}
.bor2 {
  text-align: center;
  cursor: pointer;
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.view-phone {
  display: none;
}
@media screen and (max-width: 40em) {
  .display {
    display: none !important;
  }
  .reponsive-celular {
    padding-right: 26px !important;
    padding-left: 18px !important;
  }
  .wrap-pic1 {
    width: 100%;
  }
  .view-phone {
    display: block;
  }
  .logingridcontrol1 {
    display: none;
  }
  .texto-sistema {
    margin-top: 12vw;
  }
  .img-footer-phone {
    width: 37vw;
    margin-left: 25vw;
    margin-top: 25vw;
  }
}
</style>
